import { SLETAT_HOST_NAME_PUBLIC, SLETAT_HOTELS_HOST_NAME, STATIC_HOST_NAME } from '../../consts/hosts';

export const HOTEL_PHOTO_URL = `//${SLETAT_HOTELS_HOST_NAME}/i/im/`;
export const HOTEL_PHOTO_SPRITE_URL = `//${SLETAT_HOTELS_HOST_NAME}/i/spr/`;

export const AIR_COMPANY_LOGO_URL = `//${STATIC_HOST_NAME}/images/avia/`;
export const RESORT_IMAGE_HANDLER_URL = `//${SLETAT_HOST_NAME_PUBLIC}/Services/ResortImageHandler.ashx`;

export const PLACEHOLDER_IMAGE_HANDLER_URL = `//${STATIC_HOST_NAME}/images/placeholder/tour`;
